export default __webpack_public_path__ + "static/media/whatsapp.dccfb8b3.svg";